import axios from "axios";
import {urlDashboard} from "../../../../../constants/endpoints";

export const getHomeData = (data) => {
    return axios.post(`${urlDashboard}/home`, data);
}